import type { ComponentProps } from 'react';

import MenuItem from '@liquidweb-dev/undercurrent/MenuItem';
import TextField from '@liquidweb-dev/undercurrent/TextField';
import { countryTuples } from 'country-region-data';

const prioritySlugs = ['US'];
/** @see https://git.liquidweb.com/techdev/lw/-/blob/master/install/configs/default/lwconfig/Country.yaml */
const ignoreSlugs = ['CU', 'IR', 'KP', 'SY', ...prioritySlugs];
export const countryList = [
	...countryTuples.filter(([, slug]) => prioritySlugs.includes(slug)),
	...countryTuples.filter(([, slug]) => !ignoreSlugs.includes(slug)),
];

export type CountrySelectProps = Omit<
	ComponentProps<typeof TextField>,
	'select' | 'children'
>;

const CountrySelect = (props: CountrySelectProps) => {
	return (
		<TextField select label="Country" autoComplete="country" {...props}>
			{countryList.map(([name, slug]) => (
				<MenuItem key={name} value={slug}>
					{name}
				</MenuItem>
			))}
		</TextField>
	);
};

export default CountrySelect;
